import React from 'react';
import T from 'prop-types';
import { mapValues, pickBy } from 'lodash-es';

import { SmartChart } from '../../../../../components/Chart';
import Skeleton from '../../../../../components/Skeleton';
import { columnChartConfig } from './config';
import { basePartialFilters } from '../../../configs/chart-config';

const IndexedChart = ({ metricOption, series, isPending, isPress }) => {
  const metricSeries = pickBy(series, (_, key) => key === `${metricOption.value}_index`);

  const metaSeries = mapValues(metricSeries, () => ({
    name: metricOption.label,
    color: '#348BE3',
    visible: true,
    type: 'spline',
  }));

  const chartConfig = columnChartConfig({
    series: metricSeries,
    type: 'spline',
    unit: '',
    tooltipPrecision: 2,
    yAxisPrecision: 1,
    isPress,
  });

  return (
    <div className="indexed-chart">
      <p className="eyebrow">Indexed</p>
      {isPending ? (
        <Skeleton height={234} className="d-flex" />
      ) : (
        <SmartChart
          chartId="market-indexed-chart"
          series={metricSeries}
          metaSeriesData={metaSeries}
          config={chartConfig}
          allowPartialPeriods
          filters={basePartialFilters}
        />
      )}
    </div>
  );
};

IndexedChart.propTypes = {
  metricOption: T.shape({
    value: T.string,
    label: T.string,
  }).isRequired,
  series: T.object,
  isPending: T.bool,
  isPress: T.bool,
};

export default IndexedChart;
